/**
 * @file utils/dataTransform/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const STUB = "stub";
export const EXTERNAL_TYPES = ["nonpolopolyURL", STUB];
export const MEDIA_TYPES = ["audio", "video"];

export const OVERRIDE_CATEGORY = {
    communityWidgetCategory: "/community",
    override: "topstories",
};

export const NORMAL = "Normal";

export const COMING_UP = "Coming Up";

export const RELATED_LINK = "relatedlink";

export const VIDEO = "video";

export const BULLETPOINT = "bulletpoint";
